<mat-sidenav-container class="layout-shell">
  <!-- ═══ SIDEBAR ═══ -->
  <mat-sidenav
    #sidenav
    [mode]="isDesktop() ? 'side' : 'over'"
    [opened]="isDesktop()"
    class="layout-sidebar"
    data-testid="sidebar"
  >
    <!-- Logo -->
    <a routerLink="/" class="layout-logo" aria-label="Brijjworks home" data-testid="app-logo">
      <img [src]="portalTheme.logoPath()" alt="" class="layout-logo-img" aria-hidden="true" />
      <div class="layout-logo-text">
        <div class="layout-logo-brand">Brijjworks</div>
        <div class="layout-logo-sub">{{ portalTheme.portalLabel() }}</div>
      </div>
    </a>

    <!-- Navigation -->
    <mat-nav-list class="layout-nav">
      @for (sec of sections(); track sec.title) {
        <div class="layout-section">
          @if (sec.title) {
            <div class="layout-section-title">{{ sec.title }}</div>
          }
          @for (item of sec.items; track item.route) {
            <a
              mat-list-item
              class="layout-nav-item"
              [routerLink]="item.route"
              routerLinkActive="active"
              (mouseenter)="prefetch(item.route)"
              [attr.data-testid]="'sidebar-nav-' + item.route.replace('/', '')"
            >
              <app-icon
                [name]="item.icon"
                [size]="16"
                matListItemIcon
                class="layout-nav-icon"
                aria-hidden="true"
              ></app-icon>
              <span matListItemTitle class="layout-nav-label">{{ item.label }}</span>
              @if (item.badge) {
                <span class="layout-nav-badge">{{ item.badge }}</span>
              }
            </a>
          }
        </div>
      }
    </mat-nav-list>
  </mat-sidenav>

  <!-- ═══ MAIN ═══ -->
  <mat-sidenav-content class="layout-main">
    <!-- Toolbar -->
    <mat-toolbar class="layout-toolbar">
      @if (!isDesktop()) {
        <button mat-icon-button (click)="sidenav.toggle()" aria-label="Toggle navigation menu">
          <app-icon name="menu" [size]="20" aria-hidden="true"></app-icon>
        </button>
      }

      <span class="layout-toolbar-title" data-testid="shell-page-title">{{ activeCrumb() }}</span>
      <span class="spacer"></span>

      <!-- Navbar profile -->
      <div
        class="layout-profile-wrap"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        role="presentation"
      >
        <button
          type="button"
          class="layout-profile-btn"
          (click)="profileOpen.set(!profileOpen())"
          [attr.aria-expanded]="profileOpen()"
          aria-label="User profile menu"
          data-testid="profile-cluster"
        >
          <div class="layout-avatar">{{ currentUser.initials() }}</div>
          <div class="layout-user-info">
            <span class="layout-user-name">{{ currentUser.displayName() }}</span>
            <span class="layout-user-role">{{ profileSubtitle() }}</span>
          </div>
          <app-icon
            name="chevron-down"
            [size]="12"
            class="layout-profile-chevron"
            [class.rotated]="profileOpen()"
            aria-hidden="true"
          ></app-icon>
        </button>
        @if (profileOpen()) {
          <div class="profile-panel">
            <div class="pdd-hero">
              <div class="pdd-hero-avatar">{{ currentUser.initials() }}</div>
              <div class="pdd-hero-name">{{ currentUser.displayName() }}</div>
              <div class="pdd-hero-email">{{ currentUser.email() }}</div>
              <a routerLink="/profile" class="pdd-profile-btn" (click)="profileOpen.set(false)">My Profile</a>
            </div>
            <button type="button" class="pdd-signout-btn" (click)="signOut()">Sign Out</button>
          </div>
        }
      </div>
    </mat-toolbar>

    <!-- Content -->
    <main id="main-content" tabindex="-1" class="layout-content">
      <ng-content />
    </main>

    <!-- Mobile bottom navigation — hidden ≥1024px via component CSS -->
    <app-bottom-nav [tabs]="bottomNavTabs" />
  </mat-sidenav-content>
</mat-sidenav-container>

@if (checkingTcGate()) {
  <div class="layout-tc-checking" role="status" aria-live="polite">
    <mat-spinner diameter="32" />
    <p>Checking your account…</p>
  </div>
}

@if (currentUser.tcGate(); as gate) {
  @if (gate.requiresReAcceptance) {
    <app-tc-acceptance-dialog
      [gate]="gate"
      [submitting]="acceptingTc()"
      (accepted)="onTcAccepted()"
      (cancelled)="onTcCancelled()"
    />
  }
}

<!-- Signal-backed toast stack — replaces MatSnackBar -->
<app-toast-host />
